module.exports = (__webpack_require__(2))("./core/utils.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/utils.js from dll-reference base
// module id = 41
// module chunks = 22